<template lang="pug">
  #app
    Home
</template>

<script>
import Home from '@/views/Home.vue'

export default {
  name: 'app',
  components: {
    Home,
  },
}
</script>

<style lang="stylus">
  @import './styles/_reset.styl'
  #app
    font-family 'Avenir', Helvetica, Arial, sans-serif
    -webkit-font-smoothing antialiased
    -moz-osx-font-smoothing grayscale
    text-align center
    width 100%
    overflow-x hidden
    background-color: #fff
</style>
